import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Image as ImageIcon, LogOut, Flame, Store } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/banners", label: "Banners", icon: ImageIcon },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && (!user || user.role !== "admin")) navigate("/admin/login");
  }, [ready, user, navigate]);

  if (!ready || !user || user.role !== "admin") {
    return <div className="min-h-screen flex items-center justify-center text-[#4A148C] font-display text-xl">Loading admin…</div>;
  }

  return (
    <div className="min-h-screen bg-[#FFF9F2] flex">
      <aside className="w-64 bg-[#4A148C] text-[#FFF9F2] flex flex-col">
        <div className="p-6 border-b border-[#6A2AB0]">
          <div className="flex items-center gap-3">
            <Flame className="w-6 h-6 text-[#FFB300] diya-flame" />
            <div>
              <div className="font-display text-xl">Mona&apos;s</div>
              <div className="text-[10px] tracking-widest uppercase text-[#FFCF52]/80">Admin</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`sidenav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-full font-body text-sm transition-colors ${
                  isActive ? "bg-[#E65C00] text-white" : "text-[#FFCF52] hover:bg-[#6A2AB0]"
                }`
              }
            >
              <n.icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#6A2AB0] space-y-2">
          <Link
            to="/"
            data-testid="admin-view-store"
            className="flex items-center gap-3 px-4 py-2 rounded-full font-body text-sm text-[#FFCF52] hover:bg-[#6A2AB0] transition-colors"
          >
            <Store className="w-4 h-4" /> View Storefront
          </Link>
          <button
            data-testid="admin-logout-btn"
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            className="w-full flex items-center gap-3 px-4 py-2 rounded-full font-body text-sm text-[#FFCF52] hover:bg-[#6A2AB0] transition-colors"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col">
        <div className="glass-header px-8 py-4 flex items-center justify-between">
          <div className="font-display text-xl text-[#2C1810]">Welcome back, {user.name}</div>
          <div className="text-xs font-body text-[#5B3D2A]">{user.email}</div>
        </div>
        <main className="flex-1 p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
